import { useQuery } from '@tanstack/react-query';
import { apiGet, getHydraMembers } from '../client';
import { queryKeys } from '../queryClient';
import type { HydraCollection, ReferenceItem } from '../../types';

type ReferenceQueryOptions = { enabled?: boolean };

function useReferenceDataQuery(
  queryKey: readonly string[],
  path: string,
  options?: ReferenceQueryOptions,
) {
  return useQuery({
    queryKey,
    queryFn: () => apiGet<HydraCollection<ReferenceItem>>(path),
    select: (data: HydraCollection<ReferenceItem>) => getHydraMembers(data),
    enabled: options?.enabled ?? true,
  });
}

export function useAdministrativeTypesQuery(options?: ReferenceQueryOptions) {
  return useReferenceDataQuery(queryKeys.administrativeTypes, '/administrative_types', options);
}

export function useLanguagesQuery(options?: ReferenceQueryOptions) {
  return useReferenceDataQuery(queryKeys.languages, '/languages', options);
}

export function useSpecialitiesQuery(options?: ReferenceQueryOptions) {
  return useReferenceDataQuery(queryKeys.specialities, '/specialities', options);
}

export function useCertificationsQuery(options?: ReferenceQueryOptions) {
  return useReferenceDataQuery(queryKeys.certifications, '/certifications', options);
}

export function useSpecialistTypesQuery(options?: ReferenceQueryOptions) {
  return useReferenceDataQuery(queryKeys.specialistTypes, '/specialist_types', options);
}

export function useTaxStatusesQuery(options?: ReferenceQueryOptions) {
  return useReferenceDataQuery(queryKeys.taxStatuses, '/tax_statuses', options);
}

export function useSocialWorkerTypesQuery(options?: ReferenceQueryOptions) {
  return useReferenceDataQuery(queryKeys.socialWorkerTypes, '/social-worker-types', options);
}
